import { Grid3x3 } from "lucide-react";
import {
  LamaTeamHeatmapParamsSchema,
  defaultLamaTeamHeatmapParams,
  type LamaTeamHeatmapOutput,
  type LamaTeamHeatmapParams,
} from "@playbookai/widget-schemas";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { LamaTeamHeatmapWidget } from "./Component.js";

/**
 * LAMA Teams Over Time — dashboard-only report section (plan §13.3).
 * `TView` is the `lama/team-heatmap@1` dataset output.
 */
export const lamaTeamHeatmapDef: SqlWidgetDef<
  LamaTeamHeatmapParams,
  LamaTeamHeatmapOutput
> = {
  kind: "lamaTeamHeatmap",
  label: "Teams Over Time",
  modes: ["dashboard"],
  singleton: true,
  defaultSize: { w: 960, h: 320 },
  defaultParams: defaultLamaTeamHeatmapParams,
  Component: LamaTeamHeatmapWidget,
  storage: "sql",
  schema: LamaTeamHeatmapParamsSchema,
  accent: "cyan",
  icon: Grid3x3,
  subtitle: "Team × wave maturity heatmap",
  defaultRoster: false,
  category: "single",
  layout: { col: "full", row: 5, width: 960, height: 320 },
  dashboard: {
    icon: Grid3x3,
    defaultWidth: "full",
    category: "Operations",
    supportsTitleOverride: true,
  },
};

registerWidget(lamaTeamHeatmapDef);
